import * as React from "react";
import { parseStyle } from "../Toc/helpers";
import { ICustomerRow } from "../IUserConfig";
import "./UpperLogo.scss";

export const UpperLogo = ({ props }: { props: ICustomerRow }): JSX.Element => (
    <div className="logo-container ol-unselectable ol-control">
        <div className="esri-component upper-logo">
            {!props.link ? null : (
                <>
                    {props.logo ? (
                        <div className="logo-item">
                            <a href={props.link || ""} target="_new">
                                <img className="logo-image" src={props.logo} />
                            </a>
                        </div>
                    ) : null}

                    {props.text ? (
                        <div className="logo-item text" style={parseStyle(props.textStyle)}>
                            <span className="logo-text">{props.text}</span>
                        </div>
                    ) : null}
                </>
            )}
        </div>
    </div>
);
